<template lang="pug">
GenericCard(size='auto')
  OutstandingListCore(
    @finishLoading='$emit(`finishLoading`, $event)'
    :onlyPastDue="true"
  )
  //- .d-flex.align-items-center.justify-content-between.p-3
  //-   .d-flex
  //-     .text-large รายการค้างชำระ
  //-     LoadingIndicator.ml-2(v-if='isLoading')
  //-   CustomDatePicker(v-model='filterDate')
  //- hr.m-0
  //- //- .pt-2.pb-2.px-3
  //- //-   CustomTable(
  //- //-     :columns='tableCols'
  //- //-     :data='filteredTableData'
  //- //-   )
  //- LoadedContentWrapper.flex-fill(
  //-   :isLoading='isLoading'
  //-   :data='tableData'
  //-   @reload='loadData'
  //- )
  //-   .py-2.px-3.flex-fill
  //-     CustomTable(
  //-       :columns='tableColumns'
  //-       :data='filteredTableData'
  //-       :showIndexes='true'
  //-       :showNotificationDots='true'
  //-     )
  //-       //- @itemClicked='showModal'

  //-   .sticky-bottom.bg-white
  //-     hr.m-0
  //-     .px-4.py-3
  //-       CustomPagination(
  //-         v-model='currentPage'
  //-         :total='totalPage'
  //-         :compact='true'
  //-       )
</template>

<script>
/* eslint-disable arrow-body-style */
import OutstandingListCore from './OutstandingListCore.vue';

export default {
  components: {
    OutstandingListCore,
  },
};
</script>

<style lang="scss">
.filter-date {
  font-size: 20px;
}
</style>
